import { render } from "./trajectory.vue?vue&type=template&id=423e6f60&scoped=true"
import script from "./trajectory.vue?vue&type=script&lang=js"
export * from "./trajectory.vue?vue&type=script&lang=js"

import "./trajectory.vue?vue&type=style&index=0&id=423e6f60&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423e6f60"]])

export default __exports__